/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_UploadInputs */

const en_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const es_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir`)
};

const fr_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploader`)
};

const de_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochladen`)
};

const ja_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード`)
};

const zh_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传`)
};

const ar_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع`)
};

const id_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah`)
};

const it_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica`)
};

const ru_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить`)
};

const pt_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const ko_action_upload = /** @type {(inputs: Action_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업로드`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Action_UploadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_upload = /** @type {((inputs?: Action_UploadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_UploadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_upload(inputs)
	if (locale === "es") return es_action_upload(inputs)
	if (locale === "fr") return fr_action_upload(inputs)
	if (locale === "de") return de_action_upload(inputs)
	if (locale === "ja") return ja_action_upload(inputs)
	if (locale === "zh") return zh_action_upload(inputs)
	if (locale === "ar") return ar_action_upload(inputs)
	if (locale === "id") return id_action_upload(inputs)
	if (locale === "it") return it_action_upload(inputs)
	if (locale === "ru") return ru_action_upload(inputs)
	if (locale === "pt") return pt_action_upload(inputs)
	return ko_action_upload(inputs)
});